export default "__VITE_ASSET__u_rRFnGP__"